import { render, staticRenderFns } from "./FileLegacy.vue?vue&type=template&id=ad6a5a50&scoped=true&"
import script from "./FileLegacy.vue?vue&type=script&lang=js&"
export * from "./FileLegacy.vue?vue&type=script&lang=js&"
import style0 from "./FileLegacy.vue?vue&type=style&index=0&id=ad6a5a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6a5a50",
  null
  
)

export default component.exports